if (!customElements.get('ellexa-product-faq')) {
  customElements.define(
    'ellexa-product-faq',
    class EllexaProductFaq extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-faq-list]');
        if (!this.list) return;

        this.items = Array.from(this.list.querySelectorAll('details.ellexa-product-faq__item'));
        this.items.forEach((item) => {
          const summary = item.querySelector('summary');
          const panel = item.querySelector('.ellexa-product-faq__panel');
          if (!summary || !panel) return;

          if (item.open || item.classList.contains('is-open')) {
            item.classList.add('is-open');
            item.setAttribute('open', '');
            panel.style.height = 'auto';
          } else {
            item.classList.remove('is-open');
            panel.style.height = '0px';
          }

          summary.addEventListener('click', (event) => this.onSummaryClick(event, item));
        });
      }

      onSummaryClick(event, item) {
        event.preventDefault();

        const isOpen = item.classList.contains('is-open');

        this.items.forEach((other) => {
          if (other !== item && other.classList.contains('is-open')) {
            this.closeItem(other);
          }
        });

        if (isOpen) {
          this.closeItem(item);
        } else {
          this.openItem(item);
        }
      }

      openItem(item) {
        const panel = item.querySelector('.ellexa-product-faq__panel');
        if (!panel) return;

        item.classList.add('is-open');
        item.setAttribute('open', '');
        panel.style.height = '0px';

        requestAnimationFrame(() => {
          panel.style.height = `${panel.scrollHeight}px`;
        });

        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onEnd);
          if (item.classList.contains('is-open')) {
            panel.style.height = 'auto';
          }
        };

        panel.addEventListener('transitionend', onEnd);
      }

      closeItem(item) {
        const panel = item.querySelector('.ellexa-product-faq__panel');
        if (!panel) return;

        // Switch inactive styles immediately on click.
        item.classList.remove('is-open');

        panel.style.height = `${panel.scrollHeight}px`;
        panel.getBoundingClientRect();

        requestAnimationFrame(() => {
          panel.style.height = '0px';
        });

        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', onEnd);
          item.removeAttribute('open');
        };

        panel.addEventListener('transitionend', onEnd);
      }
    }
  );
}

/* faq-color-instant-v2 */
